module.exports = __webpack_public_path__ + "img/teach5.e5e0aac0.jpg";